<template>
  <div class="subsidy-info-component">
    <ym-popup class="subsidy-info-popup"
              v-model="visible"
              get-container="body"
              @close="handlePopupClose"
    >
      <div v-if="subsidyInfo"
           class="subsidy-info-container"
           @click="handleClose"
           v-ym-report:SUBSIDY_COUPON_CLICK="{ targetId: id }"
      >
        <ym-img class="subsidy-info-title"
                :src="require('@/assets/img/combo/subsidy_title.png')"
        />
        <div class="subsidy-info-summary">{{ subsidyInfo.summary }}</div>
        <div class="subsidy-info-coupon">
          <div class="subsidy-info-coupon-left">
            <div class="subsidy-info-coupon-title">{{ subsidyInfo.coupon.title }}</div>
            <div class="subsidy-info-coupon-deadline">{{ subsidyInfo.coupon.deadline }}</div>
          </div>
          <div class="subsidy-info-coupon-right">
            <div class="subsidy-info-coupon-price">¥{{ subsidyInfo.coupon.price }}</div>
            <div class="subsidy-info-coupon-desc">{{ subsidyInfo.coupon.desc }}</div>
          </div>
        </div>
        <div class="subsidy-info-action">
          <div class="subsidy-info-action-btn">{{ subsidyInfo.btn.text }}</div>
          <div class="subsidy-info-action-desc">{{ subsidyInfo.btn.desc }}</div>
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import validator from '@/utils/validator';
  import { getUID, setToLocalStorage, getFromStorage } from '@/utils';
  import { PRODUCT_SUBSIDY_STORAGE_KEY_PREFIX } from '@/utils/constant';

  export default {
    name: 'SubsidyInfoPopup',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      subsidyInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    watch: {
      id() {
        setTimeout(() => {
          this.handleShowPopup();
        }, 500);
      },
    },
    computed: {
      storageName() {
        const userId = getUID();
        return `${PRODUCT_SUBSIDY_STORAGE_KEY_PREFIX}userId_${userId}-${this.type}_${this.id}`;
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
      },
      handlePopupClose() {
        const now = new Date().getTime();
        const value = now + 24 * 3600 * 1000 * 2;
        setToLocalStorage(this.storageName, value);
      },
      handleShowPopup() {
        const subsidyValue = getFromStorage(this.storageName);
        const now = new Date().getTime();
        if (this.subsidyInfo == null) {
          this.visible = false;
        } else if (this.subsidyInfo && now - parseInt(subsidyValue, 10) < 0) {
          this.visible = false;
        } else {
          this.visible = true;
        }
      },
    },
    mounted() {
      this.handleShowPopup();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .subsidy-info {
    &-popup {
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
    }
    &-container {
      box-sizing: border-box;
      padding-bottom: @size-medium;
      width: 590px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: @color-white;
      border-radius: 24px;
    }
    &-title {
      width: 100%;
      height: 190px;
    }
    &-summary {
      box-sizing: border-box;
      width: 500px;
      padding: @size-medium 0;
      color: @color-text-base;
      font-size: @font-size-base;
      line-height: 1.5;
    }

    @subsidy-coupon-height: 160px;
    &-coupon {
      box-sizing: border-box;
      width: 500px;
      height: @subsidy-coupon-height;
      margin-bottom: @size-extra-medium;
      padding-left: @size-extra-small;
      display: flex;
      align-items: center;
      background: url('~@/assets/img/combo/subsidy_coupon.png') no-repeat;
      background-size: contain;

      &-left {
        box-sizing: border-box;
        width: 170px;
        height: @subsidy-coupon-height;
        padding: 0 @size-base;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-right: 1px dotted #f6d2b9;
      }
      &-title {
        margin-bottom: @size-extra-small;
        color: @color-text-base;
        font-size: @font-size-base;
        font-weight: @font-weight-bold;
        line-height: 1;
        word-break: keep-all;
      }
      &-deadline {
        color: #bca99c;
        font-size: @font-size-extra-small;
        line-height: 1;
        word-break: keep-all;
      }

      &-right {
        flex: 1;
        height: @subsidy-coupon-height;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      &-price {
        margin-bottom: @size-extra-small / 2;
        color: #ff6800;
        font-size: 56px;
        line-height: 1;
        font-weight: @font-weight-bold;
      }
      &-desc {
        color: @color-text-base;
        font-size: @font-size-base;
        line-height: 1;
      }
    }

    &-action {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-btn {
        margin-bottom: 14px;
        width: 480px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-large;
        font-weight: @font-weight-bold;
        background: #ff6800;
        border-radius: 50px;
      }
      &-desc {
        color: @color-text-lighter;
        font-size: @font-size-small;
        line-height: 1;
      }
    }
  }

</style>
